import React, { createContext, useState } from 'react';

export const TransitionContext = createContext();

export const TransitionProvider = ({ children }) => {
  const [isTransitioning, setIsTransitioning] = useState(false);

  // Sayfa geçiş animasyonu başlatan fonksiyon
  const startTransition = (callback) => {
    if (isTransitioning) return; // Geçiş zaten devam ediyorsa işlemi engelle
    
    setIsTransitioning(true);
    
    // Body'e geçiş animasyonu sınıfı ekle
    document.body.classList.add('page-transition-out');
    
    // Geçiş animasyonu süresi (300ms)
    setTimeout(() => {
      // Callback fonksiyonunu çağır (genellikle navigate)
      if (typeof callback === 'function') {
        callback();
      }
      
      // Geçiş animasyonu bittikten sonra temizle ve giriş animasyonunu başlat
      document.body.classList.remove('page-transition-out');
      document.body.classList.add('page-transition-in');
      
      // Giriş animasyonu bittikten sonra temizle
      setTimeout(() => {
        document.body.classList.remove('page-transition-in');
        setIsTransitioning(false);
      }, 500);
    }, 300);
  };

  return (
    <TransitionContext.Provider value={{ isTransitioning, startTransition }}>
      {children}
    </TransitionContext.Provider>
  );
};